// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";

function queryMapper(routeQuery) {
  var name = Js_dict.get(routeQuery, "sender_name");
  var mobile = Js_dict.get(routeQuery, "sender_mobile");
  return {
          from_address_landmark: Js_dict.get(routeQuery, "from_address_landmark"),
          from_address_lat: Js_dict.get(routeQuery, "from_address_lat"),
          from_address_long: Js_dict.get(routeQuery, "from_address_long"),
          to_address_landmark: Js_dict.get(routeQuery, "to_address_landmark"),
          to_address_lat: Js_dict.get(routeQuery, "to_address_lat"),
          to_address_long: Js_dict.get(routeQuery, "to_address_long"),
          geo_region_id: Js_dict.get(routeQuery, "geo_region_id"),
          sender_name: name !== undefined ? name : Js_dict.get(routeQuery, "customer_name"),
          sender_mobile: mobile !== undefined ? mobile : Js_dict.get(routeQuery, "customer_mobile"),
          customer_name: Js_dict.get(routeQuery, "customer_name"),
          customer_mobile: Js_dict.get(routeQuery, "customer_mobile"),
          frequency: Js_dict.get(routeQuery, "frequency"),
          brand: Js_dict.get(routeQuery, "brand"),
          is_device_mobile: Js_dict.get(routeQuery, "is_device_mobile"),
          fare_estimate_token: Js_dict.get(routeQuery, "fare_estimate_token"),
          service_category: Js_dict.get(routeQuery, "service_category"),
          utm_source: Js_dict.get(routeQuery, "utm_source"),
          utm_medium: Js_dict.get(routeQuery, "utm_medium"),
          utm_campaign: Js_dict.get(routeQuery, "utm_campaign"),
          utm_content: Js_dict.get(routeQuery, "utm_content"),
          utm_term: Js_dict.get(routeQuery, "utm_term"),
          vehicle_type: Js_dict.get(routeQuery, "vehicle_type"),
          result: Js_dict.get(routeQuery, "result"),
          prev_callback_req_id_present: Js_dict.get(routeQuery, "prev_callback_req_id_present"),
          callback_request_id: Js_dict.get(routeQuery, "callback_request_id"),
          is_existing_cust: Js_dict.get(routeQuery, "is_existing_cust"),
          lead_entry_created: Js_dict.get(routeQuery, "lead_entry_created")
        };
}

function isValidParams(query_params) {
  if (Belt_Option.isSome(query_params.fare_estimate_token) && Belt_Option.isSome(query_params.brand) && Belt_Option.isSome(query_params.customer_mobile) && Belt_Option.getWithDefault(query_params.customer_mobile, "").length === 10 && Belt_Option.isSome(query_params.sender_mobile) && Belt_Option.getWithDefault(query_params.sender_mobile, "").length === 10 && Belt_Option.isSome(query_params.frequency) && Belt_Option.isSome(query_params.from_address_landmark) && Belt_Option.isSome(query_params.from_address_lat) && Belt_Option.isSome(query_params.from_address_long) && Belt_Option.isSome(query_params.geo_region_id) && Belt_Option.isSome(query_params.from_address_lat) && Belt_Option.isSome(query_params.service_category) && Belt_Option.isSome(query_params.to_address_landmark) && Belt_Option.isSome(query_params.to_address_lat) && Belt_Option.isSome(query_params.to_address_long) && Belt_Option.isSome(query_params.result) && Belt_Option.isSome(query_params.prev_callback_req_id_present) && Belt_Option.isSome(query_params.callback_request_id) && Belt_Option.isSome(query_params.is_existing_cust)) {
    return Belt_Option.isSome(query_params.lead_entry_created);
  } else {
    return false;
  }
}

var getDefault = {
  from_address_landmark: undefined,
  from_address_lat: undefined,
  from_address_long: undefined,
  to_address_landmark: undefined,
  to_address_lat: undefined,
  to_address_long: undefined,
  geo_region_id: undefined,
  sender_name: undefined,
  sender_mobile: undefined,
  customer_name: undefined,
  customer_mobile: undefined,
  frequency: undefined,
  brand: undefined,
  is_device_mobile: undefined,
  fare_estimate_token: undefined,
  service_category: undefined,
  utm_source: undefined,
  utm_medium: undefined,
  utm_campaign: undefined,
  utm_content: undefined,
  utm_term: undefined,
  vehicle_type: undefined,
  result: undefined,
  prev_callback_req_id_present: undefined,
  callback_request_id: undefined,
  is_existing_cust: undefined,
  lead_entry_created: undefined
};

export {
  getDefault ,
  queryMapper ,
  isValidParams ,
}
/* No side effect */
